/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import {
    InspectorLoginFormData,
    LoginResponseData,
    OperatorTaxpayerLoginFormData,
    InspectorLoginParams,
} from '../api/auth/authClient.typings';
import { Notification } from '../../utils/utils';
import { createAction } from '../../utils/redux-utils';
import { LocaleId } from '../translation/i18n';
import { RouteId, RouteParam } from '../../router/routes';

export enum UserActionType {
    LOGIN_INSPECTOR = 'USER/ login inspector',
    LOGIN_OPERATOR = 'USER/ login operator',
    LOGIN_TAXPAYER = 'USER/ login taxpayer',
    LOGIN_SUCCESS = 'USER/ login success',
    LOGIN_ERROR = 'USER/ login error',

    LOGOUT_USER = 'USER/ logout user',

    CHANGE_LOCALE = 'USER/ change locale',
    SAVE_LAST_MONITORING_ROUTE = 'USER/ save last monitoring route',
    VALIDATE_USER_ACTION = 'USER/ validate user action',
    COMPLETE_VALIDATE_USER_ACTION = 'USER/ complete validate user action',
}

export const loginInspector = (formData: InspectorLoginFormData) => {
    return createAction(UserActionType.LOGIN_INSPECTOR, formData);
};

export const loginOperator = (formData: OperatorTaxpayerLoginFormData) => {
    return createAction(UserActionType.LOGIN_OPERATOR, { formData });
};

export const loginTaxpayer = (formData: OperatorTaxpayerLoginFormData) => {
    return createAction(UserActionType.LOGIN_TAXPAYER, { formData });
};

export const loginSuccess = (payload: LoginResponseData) => createAction(UserActionType.LOGIN_SUCCESS, payload);

export const loginError = (notification: Notification) => createAction(UserActionType.LOGIN_ERROR, { notification });

export const logoutUser = () => {
    return createAction(UserActionType.LOGOUT_USER);
};

export const changeLocale = (localeId: LocaleId) => {
    return createAction(UserActionType.CHANGE_LOCALE, localeId);
};

export const saveLastMonitoringRouteIdAction = (payload: {
    routeId: RouteId;
    params: Partial<Record<RouteParam, string>>;
}) => {
    return createAction(UserActionType.SAVE_LAST_MONITORING_ROUTE, payload);
};

export const validateUserAction = (userParams: InspectorLoginParams) => {
    return createAction(UserActionType.VALIDATE_USER_ACTION, userParams);
};

export const completeValidateUserAction = () => {
    return createAction(UserActionType.COMPLETE_VALIDATE_USER_ACTION);
};

export type UserAction =
    | ReturnType<typeof loginInspector>
    | ReturnType<typeof loginOperator>
    | ReturnType<typeof loginTaxpayer>
    | ReturnType<typeof loginSuccess>
    | ReturnType<typeof loginError>
    | ReturnType<typeof logoutUser>
    | ReturnType<typeof changeLocale>
    | ReturnType<typeof saveLastMonitoringRouteIdAction>
    | ReturnType<typeof validateUserAction>
    | ReturnType<typeof completeValidateUserAction>;
